(function () {
  function startCaseVideos(root) {
    var scope = root || document;
    var videos = Array.prototype.slice.call(scope.querySelectorAll('.mindify-case-inline-video video'));
    videos.forEach(function (video) {
      var src = video.getAttribute('src') || video.currentSrc || video.getAttribute('data-src');
      if (!src) return;
      if (!video.getAttribute('src')) video.setAttribute('src', src);
      video.classList.remove('mindify-deferred-video');
      video.autoplay = true;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'metadata';
      var shell = video.closest('.mindify-case-inline-video');
      if (shell) {
        shell.classList.remove('is-idle', 'is-loading');
        shell.classList.add('has-playing-video');
      }
      var loading = shell && shell.querySelector('.mindify-video-loading');
      if (loading) loading.remove();
      if (video.readyState === 0) {
        try { video.load(); } catch (error) {}
      }
      var play = video.play();
      if (play && typeof play.catch === 'function') play.catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    startCaseVideos(document);
    setTimeout(function () { startCaseVideos(document); }, 1200);
    setTimeout(function () { startCaseVideos(document); }, 3500);
  });

  document.addEventListener('shopify:section:load', function (event) {
    startCaseVideos(event.target);
  });
})();
